<div class="flex warning-message">
  <button mat-icon-button>
    <mat-icon>warning</mat-icon>
  </button>
  <div class="message">{{ data.message }}</div>
  <div class="dismiss">
    <button mat-icon-button (click)="snackbarRef.dismiss()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
